var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgManhole = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 450.939 450.939",
  style: {
    enableBackground: "new 0 0 450.939 450.939"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M225.47,40.86c-101.795,0-184.61,82.815-184.61,184.609c0,101.795,82.815,184.61,184.61,184.61 s184.61-82.815,184.61-184.61C410.08,123.675,327.265,40.86,225.47,40.86z M347.132,351.983l-6.341-6.341 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l6.06,6.06c-1.734,1.506-3.503,2.97-5.295,4.408l-5.617-5.617 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l4.755,4.755c-3.13,2.258-6.339,4.412-9.618,6.465l0.011-0.011 c1.758-1.757,1.758-4.606,0-6.363c-1.758-1.758-4.607-1.758-6.363,0l-11.213,11.214c-1.407,1.407-1.668,3.506-0.822,5.192 c-7.389,3.475-15.054,6.455-22.958,8.887l7.716-7.716c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0 l-11.214,11.214c-1.554,1.553-1.729,3.957-0.536,5.708c-2.669,0.643-5.361,1.224-8.076,1.743l-7.451-7.451 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l2.838,2.838c-7.236,0.912-14.606,1.385-22.085,1.385 c-2.979,0-5.941-0.076-8.884-0.224l-10.362-10.362c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l2.733,2.733 c-6.161-0.805-12.221-1.936-18.166-3.365l10.582-10.582c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0 l-11.214,11.214c-0.967,0.966-1.382,2.261-1.285,3.525c-8.686-2.546-17.093-5.747-25.167-9.545 c0.843-1.685,0.582-3.782-0.824-5.187c-1.756-1.758-4.607-1.758-6.363,0l-1.048,1.048c-2.095-1.124-4.163-2.291-6.207-3.496 l2.403-2.403c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-3.869,3.869 c-10.813-7.167-20.792-15.494-29.753-24.809l6.341-6.341c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0 l-6.059,6.059c-1.505-1.733-2.97-3.502-4.407-5.294l5.616-5.617c1.757-1.757,1.757-4.606-0.001-6.364 c-1.758-1.756-4.606-1.757-6.364,0.001l-4.754,4.754c-2.257-3.129-4.411-6.336-6.462-9.615l0.009,0.009 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.406-1.407-3.507-1.668-5.192-0.822c-3.475-7.388-6.455-15.053-8.886-22.957l7.715,7.715c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.552-1.554-3.957-1.729-5.708-0.536 c-0.643-2.669-1.224-5.362-1.743-8.076l7.451-7.452c1.757-1.757,1.757-4.606-0.001-6.364c-1.758-1.756-4.606-1.757-6.364,0.001 l-2.836,2.836c-0.912-7.235-1.385-14.605-1.385-22.083c0-2.979,0.076-5.94,0.224-8.883l10.362-10.362 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-2.733,2.733c0.805-6.161,1.936-12.221,3.365-18.166 l10.582,10.582c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-0.966-0.967-2.261-1.382-3.525-1.285c2.546-8.685,5.746-17.092,9.544-25.166c0.634,0.319,1.32,0.498,2.013,0.498 c1.151,0,2.304-0.439,3.183-1.318c1.757-1.758,1.757-4.607-0.001-6.364l-1.055-1.054c1.124-2.095,2.291-4.162,3.496-6.205 l2.41,2.41c0.879,0.878,2.03,1.317,3.182,1.317s2.304-0.439,3.183-1.318c1.757-1.758,1.757-4.606-0.001-6.364l-3.875-3.875 c7.167-10.813,15.493-20.791,24.808-29.752l6.346,6.347c0.879,0.879,2.031,1.318,3.183,1.318s2.303-0.439,3.182-1.317 c1.758-1.758,1.758-4.607,0.001-6.364l-6.066-6.066c1.733-1.505,3.502-2.97,5.294-4.407l5.622,5.622 c0.879,0.879,2.031,1.318,3.183,1.318s2.303-0.439,3.182-1.317c1.758-1.758,1.758-4.607,0.001-6.364l-4.761-4.762 c3.129-2.257,6.336-4.411,9.615-6.462l-0.009,0.009c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318l11.214-11.214c1.407-1.407,1.668-3.506,0.822-5.192c7.388-3.475,15.053-6.455,22.958-8.886l-7.715,7.716 c-1.758,1.757-1.758,4.606,0,6.363c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.214 c1.554-1.553,1.729-3.957,0.536-5.708c2.669-0.643,5.361-1.224,8.076-1.743l7.451,7.45c0.879,0.878,2.03,1.317,3.182,1.317 s2.304-0.439,3.183-1.318c1.757-1.757,1.757-4.606-0.001-6.364l-2.835-2.835c7.235-0.912,14.605-1.385,22.083-1.385 c2.979,0,5.941,0.076,8.884,0.224l10.361,10.362c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-2.733-2.733c6.161,0.805,12.22,1.936,18.166,3.365l-10.582,10.582 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c0.967-0.966,1.382-2.261,1.285-3.525c8.688,2.547,17.096,5.748,25.173,9.547c-0.849,1.687-0.59,3.789,0.818,5.198 c0.879,0.879,2.03,1.318,3.183,1.318c1.151,0,2.303-0.439,3.182-1.317l1.058-1.057c2.092,1.122,4.156,2.288,6.196,3.491l-2.41,2.41 c-1.757,1.758-1.757,4.606,0.001,6.364c0.879,0.878,2.03,1.317,3.182,1.317s2.304-0.439,3.183-1.318l3.875-3.875 c10.813,7.167,20.791,15.493,29.753,24.808l-6.347,6.347c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318l6.066-6.066c1.506,1.733,2.97,3.502,4.408,5.294l-5.623,5.622c-1.758,1.758-1.758,4.607-0.001,6.364 c0.879,0.879,2.031,1.318,3.183,1.318s2.303-0.439,3.182-1.317l4.762-4.762c2.258,3.13,4.412,6.338,6.464,9.617l-0.01-0.01 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214c0.878,0.879,2.03,1.318,3.182,1.318 c0.693,0,1.378-0.179,2.012-0.497c3.476,7.389,6.456,15.054,8.887,22.959l-7.717-7.717c-1.756-1.758-4.607-1.758-6.363,0 c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214c0.878,0.879,2.03,1.318,3.182,1.318c0.884,0,1.766-0.265,2.527-0.783 c0.643,2.669,1.224,5.361,1.743,8.076l-7.451,7.451c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318l2.838-2.838c0.912,7.236,1.385,14.607,1.385,22.086c0,2.979-0.076,5.94-0.224,8.883l-10.363,10.363 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l2.734-2.734 c-0.805,6.162-1.937,12.222-3.366,18.167l-10.583-10.583c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 l11.214,11.214c0.878,0.879,2.03,1.318,3.182,1.318c0.115,0,0.229-0.024,0.344-0.033c-2.547,8.689-5.749,17.099-9.549,25.176 c-1.686-0.845-3.785-0.584-5.191,0.823c-1.758,1.757-1.758,4.606,0,6.363l1.051,1.051c-1.122,2.092-2.288,4.157-3.491,6.197 l-2.404-2.404c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l3.87,3.87 C364.774,333.043,356.447,343.022,347.132,351.983z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M225.47,184.498c-22.592,0-40.972,18.38-40.972,40.972c0,22.593,18.38,40.973,40.972,40.973 s40.972-18.38,40.972-40.973C266.441,202.877,248.062,184.498,225.47,184.498z M225.47,257.442 c-17.629,0-31.972-14.343-31.972-31.973c0-17.629,14.343-31.972,31.972-31.972s31.972,14.343,31.972,31.972 C257.441,243.099,243.099,257.442,225.47,257.442z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M225.47,198.065c-15.111,0-27.405,12.294-27.405,27.404c0,15.111,12.294,27.405,27.405,27.405 s27.405-12.294,27.405-27.405C252.875,210.359,240.581,198.065,225.47,198.065z M225.47,243.875 c-10.148,0-18.405-8.257-18.405-18.405s8.257-18.404,18.405-18.404s18.405,8.256,18.405,18.404S235.618,243.875,225.47,243.875z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M116.514,345.639c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.213 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L116.514,345.639z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M177.433,368.066L166.22,379.28c-1.758,1.757-1.758,4.606,0,6.363 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.214c1.758-1.757,1.758-4.606,0-6.363 C182.038,366.308,179.188,366.308,177.433,368.066z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M166.22,363.215c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L166.22,363.215z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M150.155,356.852c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L150.155,356.852z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M150.155,334.425c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C151.913,339.032,151.913,336.182,150.155,334.425z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M124.546,342.107c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C122.242,341.667,123.395,342.107,124.546,342.107z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M121.364,318.361c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L121.364,318.361z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M113.332,330.893c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 C111.028,330.454,112.181,330.893,113.332,330.893z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M105.301,289.57c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214C107.059,294.176,107.059,291.327,105.301,289.57z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M94.087,278.357c-1.756-1.758-4.607-1.758-6.363,0L76.51,289.57c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213C95.845,282.963,95.845,280.114,94.087,278.357z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M79.691,274.825c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214C77.388,274.385,78.54,274.825,79.691,274.825z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M68.478,241.183c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214C66.174,240.744,67.326,241.183,68.478,241.183z "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M76.51,228.651c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L76.51,228.651z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M76.51,251.079c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0L76.51,244.715C74.752,246.472,74.752,249.322,76.51,251.079z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M90.905,263.611c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363C88.602,263.171,89.754,263.611,90.905,263.611 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M110.15,284.72c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L110.15,284.72z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M121.364,273.506c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L121.364,273.506z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M124.546,297.251c1.151,0,2.304-0.439,3.182-1.318l11.214-11.213c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.213c-1.758,1.757-1.758,4.606,0,6.363 C122.242,296.812,123.395,297.251,124.546,297.251z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M150.155,289.57c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214C151.913,294.176,151.913,291.327,150.155,289.57z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,329.575c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L155.006,329.575z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M166.22,318.361c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L166.22,318.361z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M183.796,323.211c-1.758-1.758-4.607-1.758-6.363,0l-11.213,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.214 C185.554,327.818,185.554,324.968,183.796,323.211z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M180.614,353.321c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C178.311,352.881,179.463,353.321,180.614,353.321z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M195.01,356.852c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L195.01,356.852z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M211.074,363.215c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L211.074,363.215z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M228.651,368.066c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C230.409,372.672,230.409,369.823,228.651,368.066z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M233.502,379.28l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C238.109,377.522,235.258,377.522,233.502,379.28z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M267.143,368.066l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C271.75,366.308,268.898,366.308,267.143,368.066z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M255.929,363.215c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L255.929,363.215z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M239.865,356.852c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L239.865,356.852z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M225.47,353.321c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C223.166,352.881,224.318,353.321,225.47,353.321z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M228.651,323.211c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C230.409,327.818,230.409,324.968,228.651,323.211z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M211.074,318.361c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L211.074,318.361z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M203.042,330.893c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C200.738,330.454,201.891,330.893,203.042,330.893z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M180.614,308.465c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C178.311,308.026,179.463,308.465,180.614,308.465z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M183.796,278.357c-1.756-1.758-4.607-1.758-6.363,0L166.22,289.57c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.213C185.554,282.963,185.554,280.114,183.796,278.357z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M166.22,273.506c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L166.22,273.506z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,284.72c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L155.006,284.72z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M150.155,244.715c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C151.913,249.322,151.913,246.472,150.155,244.715z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M132.578,233.501l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C137.186,231.744,134.334,231.744,132.578,233.501z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M121.364,228.651c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L121.364,228.651z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M98.938,222.288c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214 C103.545,220.53,100.693,220.53,98.938,222.288z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M90.905,218.756c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363C88.602,218.317,89.754,218.756,90.905,218.756 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M76.51,206.224c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0L76.51,199.861C74.752,201.618,74.752,204.467,76.51,206.224z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M79.691,185.115c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214C77.388,184.675,78.54,185.115,79.691,185.115z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M79.691,162.687c1.151,0,2.304-0.439,3.182-1.318l11.214-11.213c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0L76.51,155.005c-1.758,1.757-1.758,4.606,0,6.363C77.388,162.248,78.54,162.687,79.691,162.687z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M87.724,172.583c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214C85.966,167.976,85.966,170.826,87.724,172.583z "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M113.332,196.329c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 C111.028,195.889,112.181,196.329,113.332,196.329z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M110.15,166.219c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C114.758,164.461,111.906,164.461,110.15,166.219z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M121.364,206.224c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C119.606,201.618,119.606,204.467,121.364,206.224z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M150.155,199.861c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C151.913,204.467,151.913,201.618,150.155,199.861z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,239.865c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L155.006,239.865z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,211.075c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.213 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213 C159.611,209.317,156.762,209.317,155.006,211.075z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M180.35,236.946c-1.758-1.758-4.606-1.757-6.364-0.001l-7.771,7.771 c-1.758,1.758-1.758,4.606-0.001,6.364c0.879,0.879,2.031,1.318,3.183,1.318s2.303-0.439,3.182-1.317l7.771-7.771 C182.106,241.552,182.106,238.704,180.35,236.946z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M180.61,263.613c1.151,0,2.303-0.439,3.182-1.317l4.01-4.009c1.758-1.758,1.758-4.606,0.001-6.364 s-4.605-1.757-6.364-0.001l-4.01,4.009c-1.758,1.758-1.758,4.606-0.001,6.364C178.307,263.173,179.458,263.613,180.61,263.613z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M203.042,286.039c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C200.738,285.599,201.891,286.039,203.042,286.039z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M228.651,278.357c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.213 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213 C230.409,282.963,230.409,280.114,228.651,278.357z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M225.47,308.465c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C223.166,308.026,224.318,308.465,225.47,308.465z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M247.896,330.893c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 C245.593,330.454,246.745,330.893,247.896,330.893z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M255.929,318.361c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L255.929,318.361z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M273.506,323.211c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C275.264,327.818,275.264,324.968,273.506,323.211z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M270.324,353.321c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C268.021,352.881,269.173,353.321,270.324,353.321z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M284.72,356.852c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L284.72,356.852z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M295.934,345.639c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.213 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L295.934,345.639z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M323.211,334.425l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C327.818,332.667,324.967,332.667,323.211,334.425z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M303.966,342.107c1.151,0,2.304-0.439,3.182-1.318l11.213-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.758-1.758-4.607-1.758-6.363,0l-11.213,11.214c-1.758,1.757-1.758,4.606,0,6.363 C301.663,341.667,302.814,342.107,303.966,342.107z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M303.966,319.679c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C301.662,319.24,302.814,319.679,303.966,319.679z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M292.752,330.893c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C290.448,330.454,291.601,330.893,292.752,330.893z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M270.324,308.465c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C268.021,308.026,269.173,308.465,270.324,308.465z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M273.506,278.357c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.213 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213 C275.264,282.963,275.264,280.114,273.506,278.357z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M251.923,263.137c-1.758,1.757-1.758,4.606,0,6.363l4.009,4.009c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-4.009-4.009C256.53,261.379,253.679,261.379,251.923,263.137z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M247.898,286.042c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-7.764-7.764 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l7.764,7.764C245.595,285.603,246.747,286.042,247.898,286.042 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M172.583,206.224l11.213-11.214c1.758-1.757,1.758-4.606,0-6.363c-1.758-1.758-4.607-1.758-6.363,0 l-11.213,11.214c-1.758,1.757-1.758,4.606,0,6.363c0.879,0.879,2.03,1.318,3.182,1.318S171.705,207.103,172.583,206.224z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,166.219c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C159.613,164.461,156.762,164.461,155.006,166.219z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M143.792,177.433c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C148.399,175.675,145.548,175.675,143.792,177.433z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M143.792,155.005l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C148.399,153.248,145.548,153.248,143.792,155.005z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M121.364,161.369c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.213 C119.606,156.762,119.606,159.612,121.364,161.369z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M121.364,138.942c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L121.364,138.942z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M105.301,132.579c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L105.301,132.579z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M90.905,129.046c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363C88.602,128.607,89.754,129.046,90.905,129.046 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M124.546,117.833c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C122.242,117.393,123.395,117.833,124.546,117.833z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M143.792,110.151l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C148.399,108.393,145.548,108.393,143.792,110.151z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M143.792,132.579c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C148.399,130.821,145.548,130.821,143.792,132.579z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,121.365c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C159.613,119.607,156.762,119.607,155.006,121.365z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M177.433,143.792l-11.213,11.213c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.213c1.758-1.757,1.758-4.606,0-6.363 C182.04,142.035,179.188,142.035,177.433,143.792z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M177.433,172.583c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C175.675,167.976,175.675,170.826,177.433,172.583z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M195.834,189.12c1.151,0,2.303-0.439,3.182-1.317c1.758-1.758,1.758-4.606,0.001-6.364l-4.002-4.003 c-1.757-1.757-4.605-1.758-6.364-0.001c-1.758,1.758-1.758,4.606-0.001,6.364l4.002,4.003 C193.53,188.68,194.682,189.12,195.834,189.12z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M199.865,166.221c-1.758,1.757-1.758,4.606,0,6.363l7.757,7.757c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-7.757-7.757C204.473,164.463,201.621,164.463,199.865,166.221z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M270.324,263.611c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 C268.021,263.171,269.173,263.611,270.324,263.611z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M292.752,286.039c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C290.448,285.599,291.601,286.039,292.752,286.039z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M303.966,274.825c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C301.662,274.385,302.814,274.825,303.966,274.825z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M303.966,297.251c1.151,0,2.304-0.439,3.182-1.318l11.213-11.213c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.213,11.213c-1.758,1.757-1.758,4.606,0,6.363 C301.662,296.812,302.814,297.251,303.966,297.251z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M329.574,289.57c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214C331.332,294.176,331.332,291.327,329.574,289.57z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M329.574,311.998c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L329.574,311.998z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M345.639,318.361c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L345.639,318.361z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M356.853,323.211l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C361.46,321.454,358.608,321.454,356.853,323.211z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M368.066,289.57l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C372.674,287.812,369.822,287.812,368.066,289.57z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M363.216,278.357c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.213 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213 C364.974,282.963,364.974,280.114,363.216,278.357z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M345.639,273.506c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L345.639,273.506z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M337.606,286.039c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C335.303,285.599,336.455,286.039,337.606,286.039z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M329.574,244.715c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C331.332,249.322,331.332,246.472,329.574,244.715z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M303.966,252.397c1.151,0,2.304-0.439,3.182-1.318l11.213-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.758-1.758-4.607-1.758-6.363,0l-11.213,11.214c-1.758,1.757-1.758,4.606,0,6.363 C301.663,251.958,302.814,252.397,303.966,252.397z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M303.966,229.969c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213 c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.213 C301.663,229.53,302.814,229.969,303.966,229.969z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M292.752,241.183c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C290.448,240.744,291.601,241.183,292.752,241.183z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M270.59,213.993c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l7.765-7.765 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-7.765,7.765C268.832,209.386,268.832,212.236,270.59,213.993z "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M267.14,188.65l-4.003,4.003c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318 s2.304-0.439,3.182-1.318l4.003-4.003c1.758-1.757,1.758-4.606,0-6.363C271.747,186.892,268.896,186.892,267.14,188.65z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M244.715,166.219c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C249.322,164.461,246.471,164.461,244.715,166.219z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M222.288,172.583c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214C220.53,167.976,220.53,170.826,222.288,172.583 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M222.288,143.792l-11.214,11.213c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213c1.758-1.757,1.758-4.606,0-6.363 C226.896,142.035,224.044,142.035,222.288,143.792z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M199.86,121.365c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C204.468,119.607,201.616,119.607,199.86,121.365z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M195.01,132.579c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L195.01,132.579z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M177.433,127.728c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C175.675,123.122,175.675,125.971,177.433,127.728z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M177.433,98.937l-11.213,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.214c1.758-1.757,1.758-4.606,0-6.363 C182.038,97.179,179.188,97.179,177.433,98.937z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M166.22,94.086c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363L161.369,76.51c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363L166.22,94.086 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M155.006,105.3c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L155.006,105.3z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M180.614,84.192c1.151,0,2.304-0.439,3.182-1.318L195.01,71.66c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0L177.433,76.51c-1.758,1.757-1.758,4.606,0,6.363C178.311,83.752,179.463,84.192,180.614,84.192z "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M195.01,87.723c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363L199.86,105.3 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L195.01,87.723z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M211.074,94.086c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363L206.224,76.51c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L211.074,94.086z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M222.288,98.937l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C226.896,97.179,224.044,97.179,222.288,98.937z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M222.288,127.728c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214C220.53,123.122,220.53,125.971,222.288,127.728 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M239.865,132.579c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L239.865,132.579z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M244.715,121.365c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C249.322,119.607,246.471,119.607,244.715,121.365z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M267.143,143.792l-11.214,11.213c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213c1.758-1.757,1.758-4.606,0-6.363 C271.75,142.035,268.898,142.035,267.143,143.792z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M267.143,172.583c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C265.385,167.976,265.385,170.826,267.143,172.583z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M289.57,195.01c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L289.57,195.01z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M295.934,166.219c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L295.934,166.219z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M300.784,206.224c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.758-1.758-4.607-1.758-6.363,0l-11.213,11.214 C299.026,201.618,299.026,204.467,300.784,206.224z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M329.574,199.861c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 c-1.758,1.757-1.758,4.606,0,6.363c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 C331.332,204.467,331.332,201.618,329.574,199.861z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M337.606,241.183c1.151,0,2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 C335.303,240.744,336.455,241.183,337.606,241.183z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M334.425,211.075c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.213 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213 C339.03,209.317,336.181,209.317,334.425,211.075z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M356.853,233.501l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C361.46,231.744,358.608,231.744,356.853,233.501z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M356.853,262.292c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C355.095,257.686,355.095,260.536,356.853,262.292z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M368.066,267.143c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214 C372.674,265.385,369.822,265.385,368.066,267.143z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M379.279,211.075c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.213 c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.213 C383.885,209.317,381.035,209.317,379.279,211.075z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M374.43,222.288c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L374.43,222.288z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M374.43,199.861c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214C376.188,204.467,376.188,201.618,374.43,199.861z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M356.853,188.647l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C361.46,186.889,358.608,186.889,356.853,188.647z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M340.788,166.219c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L340.788,166.219z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M329.574,177.433c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L329.574,177.433z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M323.211,155.005l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C327.818,153.248,324.967,153.248,323.211,155.005z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M300.784,161.369c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.213-11.213 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.213,11.213 C299.026,156.762,299.026,159.612,300.784,161.369z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M295.934,121.365c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L295.934,121.365z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M284.72,132.579c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L284.72,132.579z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M267.143,127.728c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C265.385,123.122,265.385,125.971,267.143,127.728z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M267.143,98.937l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C271.75,97.179,268.898,97.179,267.143,98.937z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M255.929,94.086c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363L251.078,76.51c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L255.929,94.086z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M239.865,87.723c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L239.865,87.723z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M222.288,82.874c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0L222.288,76.51C220.53,78.267,220.53,81.117,222.288,82.874z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M214.256,72.978c1.151,0,2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363C211.952,72.539,213.104,72.978,214.256,72.978 z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M270.324,84.192c1.151,0,2.304-0.439,3.182-1.318L284.72,71.66c1.758-1.757,1.758-4.606,0-6.363 c-1.756-1.758-4.607-1.758-6.363,0L267.143,76.51c-1.758,1.757-1.758,4.606,0,6.363C268.021,83.752,269.173,84.192,270.324,84.192z "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M284.72,87.723c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363L289.57,105.3 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L284.72,87.723z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M300.784,94.086c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363L295.934,76.51c-1.758-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L300.784,94.086z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M300.784,116.514c0.879,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318L318.36,105.3 c1.758-1.757,1.758-4.606,0-6.363c-1.758-1.758-4.607-1.758-6.363,0l-11.213,11.214 C299.026,111.908,299.026,114.757,300.784,116.514z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M323.211,110.151l-11.214,11.214c-1.758,1.757-1.758,4.606,0,6.363 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214c1.758-1.757,1.758-4.606,0-6.363 C327.818,108.393,324.967,108.393,323.211,110.151z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M329.574,132.579c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363L329.574,132.579z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M334.425,121.365c-1.758,1.757-1.758,4.606,0,6.363l11.214,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214 C339.032,119.607,336.181,119.607,334.425,121.365z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M345.639,161.369c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.213 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.213 C343.881,156.762,343.881,159.612,345.639,161.369z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M356.853,172.583c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318l11.214-11.214 c1.758-1.757,1.758-4.606,0-6.363c-1.756-1.758-4.607-1.758-6.363,0l-11.214,11.214 C355.095,167.976,355.095,170.826,356.853,172.583z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M368.066,177.433c-1.758,1.757-1.758,4.606,0,6.363l11.213,11.214 c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318c1.758-1.757,1.758-4.606,0-6.363l-11.213-11.214 C372.674,175.675,369.822,175.675,368.066,177.433z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M334.425,105.3c0.878,0.879,2.03,1.318,3.182,1.318s2.304-0.439,3.182-1.318 c1.758-1.757,1.758-4.606,0-6.363l-11.214-11.214c-1.756-1.758-4.607-1.758-6.363,0c-1.758,1.757-1.758,4.606,0,6.363 L334.425,105.3z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#191918"
  },
  d: "M434.138,203.969h-0.143c-3.933,0-7.188-2.872-7.741-6.83 c-6.129-43.822-25.983-83.601-57.418-115.036C337.4,50.668,297.622,30.814,253.8,24.685c-3.958-0.553-6.83-3.809-6.83-7.741v-0.143 C246.97,7.538,239.433,0,230.168,0h-9.397c-9.264,0-16.801,7.537-16.801,16.801v0.143c0,3.933-2.873,7.188-6.831,7.741 c-43.822,6.129-83.601,25.983-115.035,57.418c-31.435,31.436-51.29,71.214-57.419,115.036c-0.553,3.958-3.809,6.83-7.74,6.83 h-0.143C7.537,203.969,0,211.506,0,220.771v9.397c0,9.264,7.537,16.801,16.802,16.801h0.143c3.932,0,7.188,2.873,7.74,6.831 c6.129,43.822,25.984,83.601,57.419,115.035c31.435,31.436,71.214,51.29,115.035,57.419c3.958,0.553,6.831,3.809,6.831,7.74v0.144 c0,9.264,7.537,16.801,16.801,16.801h9.397c9.265,0,16.802-7.537,16.802-16.801v-0.144c0-3.932,2.872-7.188,6.83-7.74 c43.822-6.129,83.601-25.983,115.036-57.419c31.435-31.435,51.289-71.213,57.418-115.035c0.553-3.958,3.809-6.831,7.741-6.831 h0.143c9.265,0,16.802-7.537,16.802-16.801v-9.397C450.939,211.506,443.402,203.969,434.138,203.969z M441.939,230.168 c0,4.302-3.5,7.801-7.802,7.801h-0.143c-8.332,0-15.492,6.271-16.655,14.585c-11.903,85.12-79.666,152.883-164.786,164.786 c-8.314,1.163-14.584,8.322-14.584,16.654v0.144c0,4.302-3.5,7.801-7.802,7.801h-9.397c-4.302,0-7.801-3.499-7.801-7.801v-0.144 c0-8.332-6.271-15.491-14.585-16.654c-85.119-11.903-152.882-79.666-164.786-164.786c-1.163-8.314-8.322-14.585-16.654-14.585 h-0.143C12.5,237.969,9,234.47,9,230.168v-9.397c0-4.302,3.5-7.802,7.802-7.802h0.143c8.332,0,15.491-6.27,16.654-14.584 c11.904-85.12,79.667-152.883,164.786-164.786c8.314-1.163,14.585-8.323,14.585-16.655v-0.143c0-4.302,3.499-7.801,7.801-7.801 h9.397c4.302,0,7.802,3.499,7.802,7.801v0.143c0,8.332,6.27,15.492,14.584,16.655c85.12,11.903,152.883,79.666,164.786,164.786 c1.163,8.314,8.323,14.584,16.655,14.584h0.143c4.302,0,7.802,3.5,7.802,7.802V230.168z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManhole, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/manhole.881fc6d4.svg";
export { ForwardRef as ReactComponent };